import axios from 'axios';

export const listMyPlaceCeremonyTimesService = async (user_access_key) => {
    try {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/ceremony_time/my_place/${user_access_key}`)
        .then((response) => response?.data)
        .catch((error) => {
            console.log(error);
            return false;
        });
    } catch (error) {
        return false;
    }
};

export const createCeremonyTimeService = async (payload) => {
    try {
        return await axios.post(`${process.env.REACT_APP_API_URL}/api/ceremony_time/create`, payload)
        .then((response) => response?.data === true)
        .catch((error) => {
            console.log(error);
            return false;
        });
    } catch (error) {
        return false;
    }
};

export const updateCeremonyTimeService = async (payload) => {
    try {
        return await axios.put(`${process.env.REACT_APP_API_URL}/api/ceremony_time/update`, payload)
        .then((response) => response?.data === true)
        .catch((error) => {
            console.log(error);
            return false;
        });
    } catch (error) {
        return false;
    }
};

export const deleteCeremonyTimeService = async (user_access_key, weekday, start_time) => {
    try {
        return await axios.delete(`${process.env.REACT_APP_API_URL}/api/ceremony_time/delete/${user_access_key}/${weekday}/${start_time}`)
        .then((response) => response?.data === true)
        .catch((error) => {
            console.log(error);
            return false;
        });
    } catch (error) {
        return false;
    }
};
